import { Component, OnInit, Input, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    standalone: false
})
export class MessagesComponent implements OnInit {
  private ses = inject(SuggestionEngineService);

  @Input() message;
  state: string = 'loaded';

  ngOnInit() { }

}
